<template lang="pug">
  v-container.px-10(fluid)
    v-row.table__top
      v-col.pt-2(cols="auto")
        v-btn(
          color="primary",
          @click.stop="dialogShipmentItemProduct = true, product = getCleanProduct()",
          v-if="$showEntity('Shipment', 'CreateProductFromShipment')"
          ) CREATE PRODUCT
    v-dialog(v-model='dialogShipmentItemProduct', persistent, max-width="979")
      v-card.px-10.py-5
        v-icon.dialog__close(@click='dialogShipmentItemProduct = false; disableSaveProductShipment = false;') mdi-close
        v-card-text
          template
            .h2.primary--text Create Product
            v-container.px-10(fluid)
              v-row
                v-col(cols="3")
                  v-text-field(
                    v-model="product.referenceId",
                    label="External reference",
                    :error-messages="errors['product.referenceId']",
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="product.name",
                    label="Name",
                    :error-messages="errors['product.name']",
                  )
                v-col(cols="6")
                  v-text-field(
                    v-model="product.description",
                    label="Product description"
                  )
              v-row
                v-col
                  .h3.primary--text Weight & dimensions
              v-row
                v-col(cols="4")
                  v-text-field(
                    v-model="product.width",
                    label="Width",
                    type="number",
                    min="0"
                    :error-messages="errors['product.Width']"
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="product.length",
                    label="Length",
                    type="number",
                    min="0"
                    :error-messages="errors['product.Length']"
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="product.height",
                    label="Height",
                    type="number",
                    min="0"
                    :error-messages="errors['product.Height']"
                  )
                v-col(cols="4")
                  v-select(
                    v-model="product.dimensionsUnit",
                    label='Unit',
                    :items="['in', 'ft', 'cm', 'm']",
                    :error-messages="errors['product.DimensionsUnit']",
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="product.weight",
                    label="Weight",
                    type="number",
                    min="0"
                    :error-messages="errors['product.Weight']"
                  )
                v-col(cols="4")
                  v-select(
                    v-model="product.weightUnit",
                    label="Weight Unit",
                    :items="['lb', 'kg']",
                    :error-messages="errors['product.WeightUnit']"
                  )
              v-row
                v-col
                  .h3.primary--text Details
              v-row
                v-col(cols="4")
                  v-text-field(
                    v-model="product.htsCode",
                    label="HTS Code",
                    :error-messages="errors['product.HTSCode']",
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="product.unCode",
                    label="UN Code",
                    :error-messages="errors['product.UNCode']",
                  )
                v-col(cols="2")
                  v-switch(
                    v-model="product.isHazardous",
                    label="Hazardous",
                    :error-messages="errors['product.IsHazardous']",
                  )
                v-col(cols="12")
                  v-text-field(
                    filled,
                    v-model="product.remarks1",
                    label="Remarks",
                    :error-messages="errors['product.Remarks1']",
                  )
            v-row
              v-spacer
              v-col(cols="auto")
                g-btn(color="success", @click="createProduct", :disabled="disableSaveProductShipment") Save Product
</template>

<style lang="scss" scoped>
.g-data-table .row.table__top {
  flex-grow: 0;
}

.dialog__close {
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>

<script>
import { assign } from 'lodash'
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  name: 'shipmentItem-product',
  mixins: [EntityMixin],
  data: function () {
    return {
      dialogShipmentItemProduct: false,
      disableSaveProductShipment: false,
      product: this.getCleanProduct()
    }
  },
  computed: {
    errors(){
     return this.$store.state.errors;
    }
  },
  methods: {
    /**
     * Create a new product ready to use
     */
    async createProduct() {
      try {
        await axios.post('entity/graph', this.product)
        this.disableSaveProductShipment = true;
        this.$emit('post');
        this.dialogShipmentItemProduct = false;
        this.disableSaveProductShipment = false;
      } catch (error) {
      }
    },
    /*
    Get clean product ready to set values
    */
    getCleanProduct(){
      return {
        referenceId: null,
        name: null,
        description: null,
        width: null,
        length: null,
        height: null,
        dimensionsUnit: null,
        weight: null,
        weightUnit: null,
        htsCode: null,
        unCode: null,
        isHazardous: null,
        remarks1: null,
        _Entity: 'Product',
        entityState: 4
      }
    }

  }
}
</script>
